import { Injectable } from '@angular/core';
import { LazyMapsAPILoader, LAZY_MAPS_API_CONFIG, LazyMapsAPILoaderConfigLiteral } from '@agm/core';
import { UtilitiesService } from '../services/utilities.service';

@Injectable()
export class GoogleMapsConfig implements LazyMapsAPILoaderConfigLiteral {
    constructor(utils: UtilitiesService) {
        UtilitiesService.googleMapsConfigRef = this;
    }
    apiKey: string;
}



// WEBPACK FOOTER //
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/src/app/models/google-maps-config.model.ts